var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',_vm._l((_vm.data),function(item,index){return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
      el: ("." + (item.anchor)),
      offset: -120,
      force: true,
    }),expression:"{\n      el: `.${item.anchor}`,\n      offset: -120,\n      force: true,\n    }"}],key:index,class:[("nav-item nav-" + (item.anchor)), index === 0 ? 'nav-active' : '']},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }